"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Shared_1 = require("@/components/styled-controls/Shared");
const Layout = ({ children, registrationStepCopy, subHeaderText, errorText }) => {
    return (react_1.default.createElement(Shared_1.StepInnerContainer, null,
        react_1.default.createElement(Shared_1.StepHeader, { "$hasSubheader": !!subHeaderText }, registrationStepCopy),
        react_1.default.createElement(Shared_1.StepSubheader, null, subHeaderText),
        errorText ? react_1.default.createElement(Shared_1.GeneralError, null, errorText) : null,
        react_1.default.createElement(Shared_1.StepBody, null, children)));
};
exports.default = Layout;
